import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import logo from "../images/TP-_logo-orizz-claim-color-white-text.png";
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/amotive-logo-symbol-inverted-cut.png";
import logoInvert3 from "../images/logo_proforma-removebg-preview (1).png";
import { IoIosArrowForward } from "react-icons/io";
import { FaUnlock } from "react-icons/fa";
import { FaLock } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaBell } from "react-icons/fa";
import logoQlik from "../images/qlik2.png";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Modal, Button } from "react-bootstrap";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import { RiFileList2Fill } from "react-icons/ri";

function BasicExample() {
  const [isLocked, setIsLocked] = useState(() => {
    const lockedState = localStorage.getItem("isLocked");
    return lockedState ? JSON.parse(lockedState) : true;
  });
  const [showMap, setShowMap] = useState(false);
  const handleShowMap = () => setShowMap(true);
  const handleCloseMap = () => setShowMap(false);

  const exportToExcel = () => {
    if (!downloads.length) return;

    // Prepara i dati da esportare
    const dataToExport = filteredDownloads.map((item) => ({
      "Ragione Sociale": item.ragione_sociale,
      "Nome File": item.nome_file,
      Data: new Date(item.quando).toLocaleDateString(),
    }));

    // Crea un worksheet e un workbook
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Downloads");

    // Genera file Excel e scarica
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "downloads.xlsx");
  };

  const handleLockClick = () => {
    setIsLocked(!isLocked);
  };

  useEffect(() => {
    localStorage.setItem("isLocked", JSON.stringify(isLocked));
  }, [isLocked]);

  useEffect(() => {
    let intervalId;

    if (!isLocked) {
      intervalId = setInterval(() => {
        window.location.reload();
      }, 150000);
    } else {
      intervalId = setInterval(() => {
        window.location.href = "/amotive";
      }, 150000);
    }

    return () => clearInterval(intervalId);
  }, [isLocked]);

  const [downloads, setDownloads] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredDownloads = downloads.filter((item) =>
    item.ragione_sociale?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  useEffect(() => {
    fetch("mancata_vendita_dashboard.json")
      .then((res) => res.json())
      .then((data) => {
        console.log("Dati ricevuti:", data);

        if (data?.TP?.download && Array.isArray(data.TP.download)) {
          setDownloads(data.TP.download); // Usa direttamente l'array
        } else {
          console.warn("Struttura download non valida:", data?.TP?.download);
        }
      })
      .catch((err) => console.error("Errore fetch:", err));
  }, []);

  return (
    <Navbar
      expand="lg"
      className="navbar-desktop full-width-navbar shadow sticky-navbar navbar-heigth m-3 rounded-pill mb-0 mt-2"
      style={{
        background: "rgba(121,9,9,1)",
        maxHeight: "50px",
        padding: "28px",
      }}
    >
      <Container fluid className="p-0">
        <Navbar.Brand
          href="#home"
          className="fs-3 fw-bold mx-3 d-flex align-items-center"
        >
          <img
            alt=""
            src={logo}
            className="d-inline-block align-middle logo"
            style={{ maxWidth: "150px" }}
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-responsive"
          className="me-3 border-0"
        >
          <FaBars className="text-white fs-3" /> {/* da react-icons */}
        </Navbar.Toggle>

        <Dropdown
          show={showDropdown}
          onToggle={() => setShowDropdown(!showDropdown)}
        >
          <Dropdown.Toggle
            variant="dark"
            id="dropdown-basic"
            style={{ background: "none", border: "none" }}
          >
            <FaBell className="text-white fs-3" />
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="dropdown-menu-start p-3 hide-scrollbar"
            style={{
              background: "#ffffff33",
              backdropFilter: "blur(15px)",
              border: "1px solid gray",
              maxHeight: "400px",
              overflowY: "auto",
              width: "400px",
            }}
          >
            <div className="d-flex justify-content-center mb-2 px-3">
              <button
                className="btn btn-sm btn-success w-100 p-2"
                onClick={exportToExcel}
                style={{ borderRadius: "100px" }}
              >
                Scarica Excel
              </button>
            </div>

            <div className="px-3 py-2 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Cerca ragione sociale..."
                style={{ borderRadius: "100px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {filteredDownloads.length === 0 ? (
              <Dropdown.ItemText>Nessun risultato</Dropdown.ItemText>
            ) : (
              filteredDownloads.map((item, index) => (
                <Dropdown.ItemText key={index} className="text-wrap">
                  <strong>{item.ragione_sociale}</strong>
                  <br />
                  <small>{item.nome_file}</small>
                  <br />
                  <small>
                    <b>Download:</b> {item.click} - <b>Data:</b>{" "}
                    {new Date(item.quando).toLocaleDateString()}
                  </small>
                  <hr className="my-1" />
                </Dropdown.ItemText>
              ))
            )}
          </Dropdown.Menu>
        </Dropdown>

        <Navbar.Collapse id="navbar-responsive" className="justify-content-end">
          <div
            className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-3 py-3"
            style={{ textAlign: "left" }}
          >
            {/* MAP BUTTON */}
            {/* QLIK */}
            {/* DOWNLOAD DROPDOWN */}
            {/* BRAND LINKS */}
            <div className="d-flex align-items-center">
              <Link to="/ordini-urgenti">
               
                <RiFileList2Fill className="text-light fs-4"/>
                <span className="text-light mx-2">
                  
                  ORDINI URGENTI
                </span>{" "}
              </Link>
              {/* Pulsante mappa */}
              <Button
                className="bg-transparent border-0 d-flex align-items-center justify-content-center"
                onClick={handleShowMap}
                title="Apri mappa clienti"
              >
                <FaMapMarkerAlt className="fs-6 text-light me-2" />
                <span className="text-light">MAPPA CLIENTI</span>
              </Button>

              {/* Etichetta accanto */}

              {/* Modale con mappa */}
              <Modal
                show={showMap}
                onHide={handleCloseMap}
                centered
                size="lg"
                backdrop="static"
              >
                <Modal.Header closeButton className="bg-dark text-white">
                  <Modal.Title>Clienti Technoparts</Modal.Title>
                </Modal.Header>
                <Modal.Body
                  className="p-0"
                  style={{ height: "750px", width: "100%" }}
                >
                  <iframe
                    src="https://www.google.com/maps/d/embed?mid=1mWvZYoU3sxaWH-7ejTmvF6xYTERpM9I&ehbc=2E312F"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    title="Mappa clienti Technoparts"
                  ></iframe>
                </Modal.Body>
              </Modal>
            </div>

            <div className="p-2 rounded-pill">
              <a
                href="https://dashboard.technoparts.it/qlik/tp.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  alt="Qlik"
                  src={logoQlik}
                  className="d-inline-block align-middle mb-1 rounded me-2"
                  style={{ maxWidth: "25px" }}
                />
                <span className="text-light">QLIK</span>{" "}
              </a>
            </div>

            <Link to="/proforma">
              <img
                alt="Proforma"
                src={logoInvert3}
                className="d-inline-block align-middle mb-1 logo"
                style={{ maxWidth: "25px" }}
              />
              <span className="text-light mx-2">PROFORMA</span>{" "}
            </Link>

            <Link to="/sud-ricambi">
              <img
                alt="Sud Ricambi"
                src={logoInvert}
                className="d-inline-block align-middle mb-1"
                style={{ maxWidth: "30px" }}
              />
              <span className="text-light mx-2">SUD RICAMBI</span>{" "}
            </Link>

            <Link to="/amotive">
              <img
                alt="Amotive"
                src={logoInvert2}
                className="d-inline-block align-middle mb-1 logo"
                style={{ maxWidth: "20px" }}
              />
              <span className="text-light mx-2">AMOTIVE</span>
            </Link>

            <div
              className="mx-3"
              style={{
                width: "1px",
                height: "30px",
                backgroundColor: "rgba(255, 255, 255, 1)",
              }}
            ></div>

            {/* LOCK TOGGLE */}
            <div className="toggle-button-cover mt-2">
              <div id="button-3" className="button r">
                <input
                  className="checkbox"
                  type="checkbox"
                  checked={isLocked}
                  onChange={handleLockClick}
                />
                <div className="knobs"></div>
                <div className="layer"></div>
                <span className="lock-icon" isLocked={isLocked.toString()}>
                  {isLocked ? (
                    <FaUnlock className="text-dark fs-6" />
                  ) : (
                    <FaLock className="text-dark fs-6" />
                  )}
                </span>
              </div>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;
